import React from "react";

const LoadingView = () => {
    // Currently empty until I decide whether I want to add
    // a loading indicator or not.
    return <></>;
};

export default LoadingView;
